import { useRouter } from 'next/router'
import { useBasicPopup } from '../../../../components/basic/popup/BasicPopup'
import { useConfirmPopup } from '../../../../components/basic/popup/ConfirmPopup'
import { useLogoutStudent } from '../../../../modules/auth'
import { n_account, s_menu } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../../ids/e2e/student'

export default function useHandleLogout() {
  const { t } = useTranslation()
  const { show } = useConfirmPopup()
  const basicPopup = useBasicPopup()
  const logoutStudent = useLogoutStudent()
  const router = useRouter()

  const handleLogout = () => {
    show({
      title: t(n_account.logout),
      id: 'logoutConfirm',
      body: t(s_menu.mypage.sign_out_message),
      onRightBtnClick: logoutStudent,
      rightBtnDataRef: DATA_REF_KEY.btn_modal_check,
    })
  }

  return handleLogout
}
